"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = CookiesAdvice;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_native_1 = require("react-native");
const react_native_fontawesome_1 = require("@fortawesome/react-native-fontawesome");
const pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
const useDevice_1 = require("../../hooks/useDevice");
const BigButton_1 = __importDefault(require("../GradientButton/BigButton"));
const AppText_1 = require("../AppText");
const colors_1 = require("../../common/colors");
const react_native_2 = require("react-native");
// // Imported banner images are here
// import BannerModal1 from '../../assets/images/ImageBig.png';
// import BannerModal2 from '../../assets/images/banner-start-2.jpg';
// import BannerModal3 from '../../assets/images/banner-start-3.jpg';
// import BannerModal4 from '../../assets/images/banner-start-4.jpg';
// const MODAL_IMAGES = [BannerModal1, BannerModal2, BannerModal3, BannerModal4];
const { width: SCREEN_WIDTH } = react_native_1.Dimensions.get('window');
function Bullet({ icon, title, children }) {
    return ((0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.bullet, children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.iconContainer, children: (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: icon, color: colors_1.Colors.PRIMARY_300, size: 24 }) }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.textContainer, children: (0, jsx_runtime_1.jsxs)(AppText_1.AppText, { style: styles.bulletTitle, children: [(0, jsx_runtime_1.jsxs)(AppText_1.AppText, { style: styles.boldText, children: [title, ":"] }), " ", children] }) })] }));
}
function CookiesAdvice({ shouldOpen, handleAccept }) {
    const { isMobileScreen, deviceHeight } = (0, useDevice_1.useDevice)();
    const [isScreenOverflow, setIsScreenOverflow] = (0, react_1.useState)(false);
    return ((0, jsx_runtime_1.jsx)(react_native_1.Modal, { visible: shouldOpen, transparent: true, animationType: "slide", children: (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.background, children: [(0, jsx_runtime_1.jsxs)(react_native_1.ScrollView, { contentContainerStyle: styles.scroll, children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: [
                                styles.container,
                                isMobileScreen && styles.containerMobile,
                                isScreenOverflow && styles.containerMinimalArea,
                            ], onLayout: ({ nativeEvent: { layout: { height, width } } }) => {
                                if (height > deviceHeight - 2 * 0.05 * width) {
                                    setIsScreenOverflow(true);
                                }
                                else {
                                    setIsScreenOverflow(false);
                                }
                                ;
                            }, children: (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: [styles.safeArea, isMobileScreen && styles.safeAreaMobile], children: [(0, jsx_runtime_1.jsx)(react_native_1.Image, { source: { uri: 'https://d2e4n1tcihf17q.cloudfront.net/public/summaraizerai-og-img-new.jpg' }, style: styles.bannerImage }), (0, jsx_runtime_1.jsx)(AppText_1.AppText, { style: styles.title, children: "Transform static documents into interactive experiences" }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { gap: 8, marginBottom: 12 }, children: [(0, jsx_runtime_1.jsx)(Bullet, { icon: pro_light_svg_icons_1.faFileUpload, title: "Instant Insights", children: "Upload any document for a concise, visual summary in seconds." }), (0, jsx_runtime_1.jsx)(Bullet, { icon: pro_light_svg_icons_1.faEye, title: "Interactive Learning", children: "Engage in Q&A directly with your document's content." }), (0, jsx_runtime_1.jsx)(Bullet, { icon: pro_light_svg_icons_1.faCommentDots, title: "Enhanced Collaboration", children: "Share interactive summaries to boost team engagement and understanding." }), (0, jsx_runtime_1.jsx)(Bullet, { icon: pro_light_svg_icons_1.faGlobe, title: "Universal Compatibility", children: "From research papers to novels, summarAIzer works with any text." }), (0, jsx_runtime_1.jsx)(Bullet, { icon: pro_light_svg_icons_1.faBrain, title: "Improved Retention", children: "Turn passive reading into active conversation for better comprehension." })] }), (0, jsx_runtime_1.jsx)(AppText_1.AppText, { style: styles.professionalNote, children: "Perfect for students, researchers, professionals, and curious minds." }), (0, jsx_runtime_1.jsxs)(AppText_1.AppText, { style: styles.footNote, children: ["We use cookies to enhance the user experience. By Clicking Accept, you are accepting our", ' ', (0, jsx_runtime_1.jsx)(AppText_1.AppText, { style: [styles.footNote, { textDecorationLine: 'underline' }], onPress: () => react_native_2.Linking.openURL('https://makr.ai/terms'), children: "terms" })] })] }) }), isScreenOverflow && (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { height: 1 } })] }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.buttonsContainer, children: (0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.buttonWrapper, children: (0, jsx_runtime_1.jsx)(BigButton_1.default, { style: styles.button, onPress: handleAccept, children: "Accept and Continue" }) }) })] }) }));
}
const styles = react_native_1.StyleSheet.create({
    background: {
        backgroundColor: "#12121899",
        flex: 1,
    },
    scroll: {
        flexGrow: 1,
        paddingBottom: 80,
    },
    container: {
        backgroundColor: colors_1.Colors.DARK_600,
        maxWidth: 713,
        marginHorizontal: 'auto',
        marginTop: 16,
        borderRadius: 32,
        overflow: 'hidden',
    },
    containerMobile: {
        width: '100%',
        margin: 'auto',
    },
    containerMinimalArea: {
        marginTop: '5%',
        marginBottom: '5%',
    },
    safeArea: {
        paddingHorizontal: 24,
        paddingVertical: 32,
    },
    safeAreaMobile: {
        padding: 34,
    },
    title: {
        color: colors_1.Colors.PRIMARY_300,
        fontSize: 24,
        fontWeight: "600",
        lineHeight: 28,
        marginBottom: 16,
    },
    summary: {
        marginBottom: 32,
    },
    summaryMobile: {
        marginBottom: 24,
    },
    summaryText: {
        color: colors_1.Colors.DARK_100,
        fontSize: 18,
    },
    summaryTextMobile: {
        fontSize: 14,
    },
    bannerContainer: {
        width: '100%',
        aspectRatio: 16 / 9,
    },
    swipper: {
        borderRadius: 16,
        overflow: 'hidden',
        alignItems: 'center',
    },
    bannerImage: {
        width: '100%',
        aspectRatio: 16 / 8.4,
        resizeMode: 'cover',
        borderColor: colors_1.Colors.DARK_700,
        borderWidth: 8,
        borderRadius: 8,
        marginBottom: 20,
    },
    bullet: {
        flexDirection: 'row',
        alignItems: 'flex-start',
        backgroundColor: colors_1.Colors.DARK_700,
        padding: 12,
        borderRadius: 8,
    },
    iconContainer: {
        width: 40,
        height: 40,
        borderRadius: 20,
        justifyContent: 'center',
        alignItems: 'center',
        alignSelf: 'center',
        marginRight: 16,
    },
    textContainer: {
        flex: 1,
    },
    boldText: {
        fontWeight: '600',
        color: colors_1.Colors.white,
        fontSize: 16,
    },
    bulletTitle: {
        color: colors_1.Colors.DARK_100,
        fontSize: 16,
        fontWeight: '600',
        marginBottom: 4,
    },
    bulletTitleMobile: {
        fontSize: 18,
        lineHeight: 25.2,
    },
    subtitleContainer: {
        justifyContent: 'center',
        marginBottom: 5,
    },
    subtitleContainerMobile: {
        gap: 8,
        flexDirection: 'row',
        marginBottom: 8,
        justifyContent: 'flex-start',
        alignItems: 'center',
    },
    icon: {
        position: 'absolute',
    },
    iconMobile: {
        position: 'relative',
    },
    // bulletTitle: {
    //   fontSize: 20,
    //   fontWeight: "600",
    //   lineHeight: 28,
    // },
    bulletDescription: {
        color: colors_1.Colors.DARK_200,
        fontSize: 14,
        lineHeight: 20,
    },
    bulletTextMobile: {
        fontSize: 12,
        fontWeight: '300',
        lineHeight: 18.8,
        marginLeft: 0,
    },
    footNote: {
        color: colors_1.Colors.DARK_100,
        fontWeight: "300",
        lineHeight: 22.6,
        marginTop: 2,
    },
    professionalNote: {
        color: colors_1.Colors.white,
        fontWeight: "300",
        lineHeight: 22.6,
        marginTop: 2,
    },
    buttonsContainer: {
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        borderTopLeftRadius: 12,
        borderTopRightRadius: 12,
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        padding: 20,
        // backgroundColor: Colors.DARK_700,
        width: '100%',
        maxWidth: 567,
        marginHorizontal: 'auto',
    },
    buttonWrapper: {
        flex: 1,
        marginHorizontal: 5,
    },
    button: {
        width: '100%',
    },
});
